export default {
  common: {
    search: '查询',
    reset: '重置',
    create: '新建',
    createTime: '创建时间',
    edit: '编辑',
    view: '查看',
    remove: '删除',
    back: '返回',
    save: '保存',
    cancel: '取消',
    actions: '操作',
    all: '全部',
    yes: '是',
    no: '否',
    online: '已上线',
    offline: '已下线',
    toVerify: '待验证',
    addRow: '添加行',
    code: '编码',
    name: '名称',
    status: '状态',
    version: '版本',
    remark: '备注',
    required: '必填',
    type: '类型',
    priority: '优先级',
    publish: '发布',
    compare: '对比',
    enabled: '启用',
    disabled: '停用',
    permanent: '永不过期',
    syntaxTest: '语法测试',
    loadFailed: '数据加载失败',
    syncFromTemplate: '从模板同步',
    totalItems: '共 {total} 条',
    on: '开',
    off: '关',
    test: '测试',
    delete: '删除',
    scene: '场景',
    custom: '自定义',
    submit: '提交',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    noData: '暂无数据',
  },
  layout: {
    productName: '风控决策平台',
    logoText: '',
    adminConsole: '管理控制台',
    collapse: '收起',
    expand: '展开',
    language: '语言',
    zhCN: '中文',
    enUS: 'English',
    bizRealtimeTxn: '实时交易',
    bizCompliance: '合规',
    userName: '管理员',
    keepOneTab: '至少保留一个标签页',
  },
  menuGroup: {
    architecture: '系统架构',
    access: '场景接入',
    featurePlatform: '特征平台',
    ruleCenter: '规则中心',
    rule: '规则管理',
    decision: '决策管理',
    audit: '审核发布',
    verify: '验证查询',
    system: '系统管理',
  },
  menu: {
    systemArchitecture: '系统架构',
    home: '首页',
    scenes: '场景',
    accessPoints: '接入点',
    sceneDicts: '字典',
    merchantThresholds: '商户规则阈值',
    rules: '规则列表',
    strategies: '策略',
    features: '特征字段',
    featureRates: '速率配置',
    decisionTrees: '决策流',
    decisionPublish: '决策发布',
    merchantRules: '商户自定义规则',
    verifyTraceSingle: '单笔回溯',
    verifyExecutionInstances: '执行实例',
    verifyConclusions: '风控结论',
    verifySimulate: '模拟验证',
    verifyLineage: '血缘查询',
    verifyTraceBatch: '批量回溯',
    verifyVelocityRead: '速率读取',
    verifyVelocityWrite: '速率写入',
  },
  home: {
    title: '风控决策平台',
    subtitle: '配置接入点、规则、策略与决策流',
  },
  systemArchitecture: {
    title: '风控系统',
    subtitle: '风控系统整体架构概览，包含策略决策、实时引擎、特征平台、数据基础设施等核心模块',
    s1: {
      title: '1.1 策略决策平台',
      accessPointMgmt: '接入点管理',
      strategyConfig: '策略配置',
      versionMgmt: '版本管理',
      decisionDashboard: '决策大盘',
    },
    s2: {
      title: '1.2 实时决策引擎',
      onlineApp: '在线风控应用',
      accessCheck: '准入检测',
      decisionOrchestration: '决策编排',
      decisionAction: '决策动作',
      decisionConclusion: '决策结论',
      decisionComponent: '决策组件',
      splitRouting: '分流',
    },
    s3: {
      title: '1.3 风险运营平台',
      merchantOps: '商户端运营平台',
      riskOps: '风险运营平台',
      deepQuery: '深度查询',
      actionProcess: '动作处理',
      caseWorkflow: '案件与工单',
    },
    s4: {
      title: '1.4 特征平台',
      featureGovernance: '特征治理',
      featureService: '特征服务',
      featureStorage: '特征存储',
      featureCategory: '特征分类',
    },
    s5: {
      title: '1.5 决策数据',
      dataCollection: '数据采集',
      collectionDimension: '采集维度',
      riskData: '风控数据',
      externalData: '外部数据',
    },
    s6: {
      title: '1.6 数据服务商',
    },
    s7: {
      title: '1.7 风控监控中心',
      metricMonitor: '指标监控',
      featureMonitor: '特征监控',
      alertCenter: '告警中心',
    },
    s8: {
      title: '2. 数据与基础设施',
      onlineStorage: '在线存储',
      bizStorage: '业务存储',
      streamProcessing: '流式处理',
    },
    s9: {
      title: '3. 共享组件层',
      ruleEngine: '规则引擎',
      statComponent: '统计组件',
      designLanguage: '设计语言',
    },
    s10: {
      title: '4. 长期扩展能力',
    },
  },
  fields: {
    sceneCode: '场景',
    sceneName: '场景名称',
    decisionTree: '决策树',
    defaultDecisionTree: '默认决策树',
    accessPoints: '准入点',
    fieldCode: '字段编码',
    fieldName: '字段名称',
    fieldValue: '字段值',
    accessPointCode: '准入点编码',
    accessPointName: '准入点名称',
    merchantNo: '商户号',
    merchantName: '商户名称',
    merchantId: '商户号',
    payType: '支付方式',
    orderAmount: '订单金额',
    dictCode: '字典编码',
    dictName: '字典名称',
    scope: '作用域',
    enumCode: '枚举编码',
    enumName: '枚举名称',
    customFlag: '自定义标记',
    ruleCode: '规则编码',
    ruleName: '规则名称',
    ruleDesc: '规则描述',
    ruleType: '规则类型',
    scriptType: '脚本类型',
    scriptContent: '脚本内容',
    strategyCode: '策略编码',
    strategyName: '策略名称',
    featureCode: '特征编码',
    featureName: '特征名称',
    featureRateCode: '速率编码',
    featureRateName: '速率名称',
    treeCode: '决策树编码',
    rateCode: '速率编码',
    treeName: '决策树名称',
    treeType: '决策树类型',
    commonFlag: '公共树',
    versionDesc: '版本说明',
    flow: '流程',
    leftVersion: '左侧版本',
    rightVersion: '右侧版本',
    published: '发布时间',
    lastPublishedTime: '最后发布时间',
    riskLevel: '风险等级',
    reasonCode: '原因码',
    actionCode: '处置动作',
    riskConclusion: '风控结论',
    score: '分值',
    ruleScore: '规则分数',
    timeoutMs: '超时 (ms)',
    terminal: '终止节点',
    order: '顺序',
    featureSource: '特征类型',
    valueType: '值类型',
    dimensionFlag: '是否是速率维度字段',
    subWindowPeriod: '子窗口周期',
    calcType: '计算类型',
    windowType: '窗口类型',
    windowPeriod: '窗口周期',
    maxErrorRate: '最大错误率 (%)',
    keyDimensions: 'Key维度',
    storageDimensions: '存储维度',
    window: '窗口',
  },
  flowEditor: {
    hint: '拖动画布平移；双击节点或点节点下「查看策略」进入策略详情',
    viewStrategy: '查看策略',
    viewJson: '完整数据',
    fitCanvas: '适应',
    edgeTrue: '成功',
    edgeFalse: '失败',
    title: '决策流',
    paletteSelect: '选区',
    paletteStart: '开始',
    paletteRoute: '路由条件',
    paletteStrategy: '策略',
    paletteEnd: '结束',
    toolFullscreen: '全屏',
    toolZoomIn: '放大',
    toolZoomOut: '缩小',
    toolFit: '适应',
    toolPan: '平移',
    toolSelect: '选择',
    toolMinimap: '缩略图',
    toolDownload: '下载图片',
    duplicateStart: '画布中已存在开始节点',
    duplicateEnd: '画布中已存在结束节点',
    dragHint: '从左侧拖入节点；选区模式下拖动节点与连线',
  },
  scenes: {
    title: '场景',
    create: '新建场景',
    edit: '编辑场景',
    detail: '场景详情',
    basicInfo: '基本信息',
    dimensions: '关注维度',
    created: '场景创建成功',
    updated: '场景更新成功',
  },
  accessPoints: {
    title: '准入点',
    create: '新建准入点',
    edit: '编辑准入点',
    dimensions: '匹配维度',
    dimension: '维度',
    operator: '运算符',
    value: '值',
    dimensionPlaceholder: '请选择维度',
    valuePlaceholder: '请输入值',
    statusChanged: '状态已更新',
    created: '准入点创建成功',
    updated: '准入点更新成功',
    sceneCodePlaceholder: '请选择场景',
    conditionTree: '条件表达式',
    conditionTreePlaceholder: '{"type":"condition","operator":"eq","field":"F_CHANNEL","value":"APP"}',
    conditionTreeInvalid: '维度 {field} 的条件表达式 JSON 无效',
  },
  sceneDicts: {
    title: '场景字典',
    create: '新建场景字典',
    edit: '编辑场景字典',
    enums: '枚举值',
    addEnum: '添加枚举',
    editEnum: '编辑枚举',
    created: '场景字典创建成功',
    updated: '场景字典更新成功',
    enumManagement: '枚举管理',
    deleteEnumConfirm: '确定删除该枚举？',
    enumCreated: '枚举创建成功',
    enumUpdated: '枚举更新成功',
    enumDeleted: '枚举删除成功',
    scopeCommon: '公共',
    scopeScene: '场景',
  },
  merchantThresholds: {
    title: '商户规则阈值',
    create: '新建阈值',
    edit: '编辑阈值',
    syncTitle: '从模板同步',
    created: '阈值创建成功',
    updated: '阈值更新成功',
    synced: '阈值同步成功',
    syncFieldPlaceholder: '可选 — 留空则同步全部',
    manageTitle: '管理商户 {merchantNo} 的阈值',
    manage: '管理',
    merchantNoPlaceholder: '请输入商户号',
    merchantNamePlaceholder: '请输入商户名称',
    riskLevelPlaceholder: '请输入风险等级',
  },
  merchantRules: {
    title: '商户自定义规则',
    create: '新建商户规则',
    edit: '编辑商户规则',
    detail: '商户规则详情',
    basicInfo: '基本信息',
    templateConfig: '规则模板',
    thresholdConfig: '阈值参数',
    overrideConfig: '处置覆盖（留空继承平台默认值）',
    filterMerchantNoPlaceholder: '请输入商户号',
    filterRuleCodePlaceholder: '请输入规则编码',
    merchantNoPlaceholder: '请输入商户号',
    ruleCodePlaceholder: '请选择规则模板',
    thresholdParamsHint: '根据所选规则模板的占位符动态生成，请参考模板说明填写',
    actionCodeInherit: '留空则继承平台默认处置',
    riskConclusionInherit: '留空则继承平台默认结论',
    riskLevelInherit: '留空则继承平台默认等级',
    ruleScoreInherit: '留空则继承平台默认分值',
    created: '商户规则创建成功',
    updated: '商户规则更新成功',
    deleted: '商户规则删除成功',
    disabled: '商户规则已禁用',
    enabled: '商户规则已启用',
    statusChanged: '商户规则状态已更新',
    deleteConfirm: '确定删除该商户规则？删除后剩余规则将重新发布策略',
    disableConfirm: '确定禁用该商户规则？禁用后将重新发布策略',
    ruleCodeExists: '该商户已配置此规则，请直接编辑',
    templateRequired: '请先选择规则模板',
    noExposedTemplates: '暂无暴露的规则模板，请先在规则模板管理中配置',
    defaultAction: '平台默认：{value}',
    defaultEmpty: '平台未配置默认值',
  },
  rules: {
    title: '规则',
    create: '新建规则',
    edit: '编辑规则',
    detail: '规则详情',
    syntaxTestTitle: '规则语法测试',
    scriptComponent: '规则组件',
    ruleOutput: '规则输出',
    filterNamePlaceholder: '请输入规则名称',
    filterCodePlaceholder: '请输入规则编码',
    created: '规则创建成功',
    updated: '规则更新成功',
    statusChanged: '规则状态已更新',
    syntaxValid: '语法校验通过',
    syntaxTestRequired: '请先通过语法测试再保存',
    basicInfo: '规则信息',
    scriptConfig: '规则脚本',
  },
  strategies: {
    title: '策略',
    create: '新建策略',
    edit: '编辑策略',
    detail: '策略详情',
    ruleRels: '规则关联',
    syntaxTestTitle: '策略语法测试',
    created: '策略创建成功',
    updated: '策略更新成功',
    statusChanged: '策略状态已更新',
    syntaxTestResult: '语法测试结果',
    addRule: '添加规则',
    typeScriptRequired: '策略类型和脚本类型为必填项',
    basicInfo: '基本信息',
    scriptConfig: '脚本配置',
    branchStrategy: '分支策略',
    createBranch: '分支脚本',
  },
  features: {
    title: '特征字段',
    create: '新建特征',
    edit: '编辑特征',
    metaFieldName: '元字段',
    fieldFormat: '字段格式',
    fieldSource: '特征类型',
    accessMode: '接入方式',
    filterNamePlaceholder: '请输入元字段名称',
    filterCodePlaceholder: '请输入字段编码',
    created: '特征创建成功',
    updated: '特征更新成功',
    statusChanged: '特征状态已更新',
    basicInfo: '基本信息',
    rateConfig: '速率配置',
    scriptConfig: '脚本配置',
  },
  featureRates: {
    title: '速率配置',
    create: '新建速率',
    edit: '编辑速率',
    detail: '速率详情',
    factorCode: '因子编码',
    factorName: '因子',
    factorType: '因子类型',
    factorTag: '因子标签',
    filterNamePlaceholder: '请输入因子名称',
    filterCodePlaceholder: '请输入因子编码',
    conditionTreeJson: '条件树 (JSON)',
    created: '速率创建成功',
    updated: '速率更新成功',
    statusChanged: '速率状态已更新',
    basicInfo: '基本信息',
    windowConfig: '窗口配置',
    dimensionConfig: '维度配置',
    conditionConfig: '筛选逻辑',
    keyDimensionsPlaceholder: '选择Key维度',
    redisKeyExample: 'Redis Key 示例',
    storageDimensionsPlaceholder: '输入存储维度，回车添加',
  },
  decisionTrees: {
    title: '决策流',
    create: '新建决策树',
    edit: '编辑决策树',
    detail: '决策树详情',
    compareVersions: '版本对比',
    compareResult: '对比结果',
    basicInfo: '基本信息',
    versions: '版本历史',
    viewFlowJson: '查看流程 JSON',
    flowJson: '流程 JSON',
    strategiesInFlow: '流程中的策略',
    invalidFlowJson: '流程 JSON 格式无效',
    created: '决策树创建成功',
    updated: '决策树更新成功',
    published: '已发布版本 {version}',
    left: '左侧',
    right: '右侧',
  },
  versionPublish: {
    title: '版本发布',
    placeholder: '发布目录与发布记录功能建设中，当前可在决策流详情中执行发布操作。',
    goDecisionFlow: '前往决策流',
  },
  decisionPublish: {
    title: '决策发布',
    detail: '发布详情',
    manage: '发布管理',
    versionHistory: '版本历史',
    compareVersions: '版本对比',
    compareResult: '对比结果',
    published: '已发布版本 {version}',
  },
  verify: {
    traceSingle: '单笔回溯',
    executionInstances: '执行实例',
    executionDetail: '执行详情',
    conclusions: '风控结论',
    conclusionDetail: '结论详情',
    simulate: '模拟验证',
    lineage: '血缘查询',
    traceBatch: '批量回溯',
    velocityRead: '速率读取',
    velocityWrite: '速率写入',
    txnId: '交易流水号',
    endpointCode: '准入点',
    decisionTreeName: '决策流名称',
    txnStage: '交易阶段',
    conclusion: '决策结论',
    runMode: '运行模式',
    startTime: '开始时间',
    hitRules: '命中规则',
    orderInfo: '订单信息',
    requestJson: '请求 JSON',
    requestJsonEmpty: '暂无请求 JSON',
    executionChain: '执行链',
    ruleCode: '规则编码',
    queryType: '查询类型',
    entityCode: '编码',
    relatedFeatures: '关联特征',
    relatedStrategies: '关联策略',
    relatedDecisionTrees: '关联决策流',
    relatedRules: '关联规则',
    noLineageData: '暂无关联数据',
    simulateInput: '模拟入参 (JSON)',
    simulateExecute: '模拟执行',
    trace: '回溯',
    query: '查询',
    comingSoonTitle: '功能建设中',
    comingSoonDesc: '该功能依赖特征计算或批量任务能力，后续版本接入。',
    noTraceData: '未找到该交易的决策记录',
    simulateHint: '规则脚本语法校验，用于快速检查 QLExpress 表达式是否合法。',
    simulateRuleTab: '规则语法',
    simulateDecisionTreeTab: '决策流模拟',
    simulateDecisionTreeHint: '调用引擎 test 方法 dry-run，默认按当前画布草稿构建 XML；关闭「使用草稿」则优先读取最近发布快照。',
    latestRequestLoaded: '已带出该决策树最近一次请求入参，关键 Id 字段已按雪花算法重新生成',
    noLatestRequest: '未找到该决策树的最近请求数据，请手动填写模拟入参',
    latestRequestFailed: '带出最近请求数据失败，请手动填写模拟入参',
    useDraftFlow: '使用草稿画布',
    xmlSource: 'XML 来源',
    decisionResult: '决策结果',
    ruleTraceList: '规则执行轨迹',
    strategyTraceList: '策略执行轨迹',
    velocityReadHint: '直连 Redis 读取速率/特征缓存，Key 格式示例：feature:rate:{rateCode}:{dimKey}',
    redisKey: 'Redis Key',
    redisDataType: '数据类型',
    redisTtl: 'TTL (秒)',
    redisExists: '是否存在',
    redisValue: '值',
    velocityWriteHint: '速率写入能力暂未开放，请通过交易链路或特征计算服务写入。',
    matched: '匹配',
    executionFlowCanvas: '决策流执行路径',
    executionFlowEmpty: '暂无决策树画布或执行轨迹数据（历史交易可能未写入 ext_info）',
    flowSource: '画布来源',
    flowSourceSnapshot: '发布快照',
    flowSourceDefinition: '当前定义',
    executedStrategyCount: '执行策略数',
    totalExecutionCost: '执行总耗时',
    executionChainEmpty: '暂无执行链数据',
    chainNode: '节点',
    chainResult: '结果',
    chainCost: '耗时',
    chainPass: '成功',
    chainFail: '失败',
  },
  messages: {
    invalidJson: 'JSON 格式无效',
    valid: '有效',
    invalid: '无效',
    invalidConditionTreeJson: '条件树 JSON 格式无效',
  },
}
